<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="120px"
    />
  </div>
</template>
<script>
import { mapState, mapMutations, mapAction } from 'vuex'
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Jigouguanli',
  data() {
    return {
      url: '/org/page',
      columns: [
        {
          label: '企业名称',
          prop: 'name'
        },
        {
          label: '企业身份',
          prop: 'orgType',
          template: (index, record) => {
            return this.getOrgTypeValue(record.orgType)
          }
        },
        {
          label: '运营商名称',
          prop: 'operatorName',
          template: (index, record) => {
            return record.operatorName ? record.operatorName : '--'
          }
        },
        {
          label: '运营商属性',
          prop: 'attr',
          template: (index, record) => {
            return this.getAttrValue(record.attr)
          }
        },
        {
          label: '统一社会信用代码',
          prop: 'code'
        },
        {
          label: '联系人',
          prop: 'contactUser'
        },
        {
          label: '联系方式',
          prop: 'contactNum'
        },
        {
          label: '邮箱',
          prop: 'email'
        },
        {
          label: '是否限制电站',
          prop: 'limitStation',
          template: function(index, record) {
            // 只有车辆机构才有是否限制站点这个字段信息
            if (record.orgType === 1) {
              if (record.limitStation) {
                return '是'
              } else {
                return '否'
              }
            } else {
              return '--'
            }
          }
        },
        {
          label: '状态',
          prop: 'frozen',
          template: function(index, reocrd) {
            return !reocrd.frozen
              ? "<div class='circle green'></div><span>正常</span>"
              : "<div class='circle red'></div><span>冻结</span>"
          }
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'business.enterprise.details',
            handle: res => {
              this.$router.push({
                path: './operatorDetail',
                query: {
                  data: res.id
                }
              })
            }
          },
          {
            label: '冻结',
            permission: 'business.enterprise.frozen',
            style: 'color:red',
            getLabel: function(record) {
              return record.frozen ? '恢复' : '冻结'
            },
            getLabelStyle: record => {
              return record.frozen ? 'color:#409EFF' : 'color:red'
            },
            url: '/org/frozen',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '修改',
            permission: 'business.enterprise.update',
            handle: res => {
              this.$router.push({ path: './modifyOperatormanagement', query: { data: res.id }})
            }
          },
          {
            label: '企业钱包',
            permission: 'business.enterprise.corporatewallet',
            handle: res => {
              this.$router.push({
                path: './operatorWallet',
                query: {
                  id: res.id
                }
              })
            },
            isShowFun: record => {
              return record.orgType === 1
            }
          },
          {
            label: '删除',
            permission: 'business.enterprise.delete',
            getLabelStyle: record => {
              return record.name === this.$store.state.login.companyName ? 'color: #c0c4cc;cursor: not-allowed;' : 'color: red;'
            },
            getLabelDisabled: (record) => {
              return record.name === this.$store.state.login.companyName
            },
            url: '/org',
            method: 'delete',
            confirmText: '删除企业会将该企业下的子企业一并删除，是否确定删除？',
            isConfirm: true,
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              })
              this.$refs.tableref.queryTable()
              this.$store.dispatch('login/getCur')
              this.$store.dispatch('login/getMenu')
            }
          }
        ]
      },
      query: [
        {
          label: '企业名称',
          prop: 'name',
          placeholder: '请输入企业名称'
        },
        {
          label: '统一社会信用代码',
          prop: 'code',
          placeholder: '请输入统一社会信用代码'
        },
        {
          label: '联系人',
          prop: 'contactUser',
          placeholder: '请输入联系人'
        },
        {
          label: '联系方式',
          prop: 'contactNum',
          placeholder: '请输入联系方式'
        },
        {
          label: '邮箱',
          prop: 'email',
          placeholder: '请输入邮箱'
        },
        {
          label: '企业身份',
          prop: 'orgType',
          placeholder: '请选择企业属性',
          type: 'select',
          data: [
            {
              label: '运营商',
              value: 0
            }, {
              label: '车辆机构',
              value: 1
            }, {
              label: '流量方',
              value: 2
            }
          ]
        },
        {
          label: '运营商属性',
          prop: 'attr',
          placeholder: '请选择运营商属性',
          type: 'select',
          data: [
            {
              label: '自营',
              value: 0
            }, {
              label: '加盟',
              value: 1
            }, {
              label: '互联互通',
              value: 2
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'business.enterprise.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addOperatormanagement')
          }
        }
      ]
    }
  },
  methods: {
    getOrgTypeValue: function(orgType) {
      if (orgType === 0) {
        return '电站运营商'
      } else if (orgType === 1) {
        return '车辆机构'
      } else if (orgType === 2) {
        return '流量方'
      } else if (orgType === 3) {
        return '混合型'
      } else {
        return '--'
      }
    },
    getAttrValue: function(attrValue) {
      if (attrValue === 0) {
        return '自营'
      } else if (attrValue === 1) {
        return '加盟'
      } else if (attrValue === 2) {
        return '第三方'
      } else {
        return '--'
      }
    }
  }
}
</script>
  <style lang="less" src="" scoped>
  </style>



// WEBPACK FOOTER //
// src/views/organManagement/operatormanagement.vue